<template>
  <div>
    <div class="guanyuwomen">
      <div class="font-box">
        <div class="font">
          <img src="@/assets/xinxifont.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="about-nav">
      <div class="about-nav-content">
        <div>
          <div
            v-for="(v, i) in navList"
            :key="i"
            :class="i == curIndex ? 'navAcitve' : 'navAcitveNo'"
            @click="navLeft(i, v.linkTo)"
          >
            {{ v.name }}
          </div>
        </div>
        <div>
          <span><img src="@/assets/dingwei.png" alt="" /></span>
          <span @click="$router.push('/index?index=0')"><span class="acitvea">首页</span> ></span>
          <span @click="$router.push('/information?index=3&title=信息公示&curIndex=0')"><span class="acitvea">{{ title }}</span> ></span>
          <span @click="goGo" class="acitvea">{{ navList[curIndex] && navList[curIndex].name }}</span>
          <span v-if="type==5" style="margin-left:2px">> <span class="acitvea">详情</span></span>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  updated() {
    this.type = this.$route.query.type;
    this.navIndex = this.$route.query.index;
    this.title = this.$route.query.title;
    this.curIndex = this.$route.query.curIndex;
    localStorage.setItem("currentIndex", this.navIndex);
  },
  mounted() {
    this.type = this.$route.query.type;
    this.navIndex = this.$route.query.index;
    this.title = this.$route.query.title;
    this.curIndex = this.$route.query.curIndex;
    localStorage.setItem("currentIndex", this.navIndex);
  },
  data() {
    return {
      title: "",
      navList: [
        { name: "希冀月刊", linkTo: "/information" },
        { name: "希冀年报", linkTo: "/information/yearly" },
        { name: "理事会议", linkTo: "/information/meeting" },
        { name: "审计报告", linkTo: "/information/auditReport" },
        { name: "管理制度", linkTo: "/information/management" },
      ],
      navIndex: "",
      curIndex: "",
      type: "",
    };
  },
  methods: {
    navLeft(i, path) {
      this.curIndex = i;
      this.$router.push({
        path: path,
        query: {
          index: 3,
          title: this.title,
          curIndex: this.curIndex,
        },
      });
    },
    goGo(){
      this.$router.push({
        path:this.navList[this.curIndex].linkTo,
        query: {
          index: 3,
          title: this.title,
          curIndex: this.curIndex,
        },
      })
    }
  },
};
</script>
<style scoped lang="scss">
.acitvea {
  &:hover {
    color: #c1141e;
  }
}
.navAcitve {
  color: #c1141e;
}
.navAcitveNo {
  color: #333333;
}
.about-nav {
  width: 100%;
  height: 62px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 23, 49, 0.06);
  .about-nav-content {
    width: 1200px;
    height: 62px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div:nth-child(1) {
      display: flex;
      > div:not(:first-child) {
        margin-left: 28px;
      }
    }
    > div:nth-child(2) {
      color: #999999;
      > span:nth-child(1) {
        img {
          vertical-align: text-bottom;
        }
      }
      > span:nth-child(2) {
        margin-left: 9px;
      }
      > span:nth-child(3),
      span:nth-child(4) {
        margin-left: 4px;
      }
    }
  }
}
.guanyuwomen {
  width: 100%;
  height: 320px;
  background-image: url("../../assets/gongshi2.png");
  background-size: 1920px 320px;
  background-repeat: no-repeat;
  background-position: top center;
}
.font-box{
  width: 1200px;
  height: 320px;
  margin: 0 auto;
  position: relative;
  
}
.font {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-29px);
}
</style>